import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Button from "@commons/Button";
import { useState } from "react";
import Text from "@commons/Typography/Text";
import { usePage } from "@hooks/usePage";
import { config } from "@/config";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "@hooks/usePermissions";

function NavbarList() {
  const [open, setOpen] = useState<Record<string, boolean>>({});
  const { activePage } = usePage();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const handleToggle = (label: string) => {
    setOpen((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const handleClick = (path?: string) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <List className="space-y-3 w-full overflow-y-auto px-4">
      {config.pages.map((item) => {
        if (item.outsideMenu) return null;
        if (!hasPermission(item.roles)) return null;

        return item.subpages ? (
          <div key={item.label}>
            <div className="bg-background rounded-3xl">
              <Button
                customVariant="muted"
                size="full"
                onClick={() => handleToggle(item.label)}
              >
                <div className="flex-1 text-center">
                  <Text>{item.label}</Text>
                </div>
                <span className="absolute right-4">
                  {open[item.label] ? <ExpandLess /> : <ExpandMore />}
                </span>
              </Button>
              <Collapse in={open[item.label]} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  className="pt-2 pb-3 space-y-2 px-2"
                >
                  {item.subpages
                    .filter((sub) => hasPermission(sub.roles))
                    .map((sub) => (
                      <Button
                        key={sub.path}
                        customVariant={
                          activePage === sub.label ? "primary" : "muted"
                        }
                        size="full"
                        className="text-md"
                        onClick={() => handleClick(sub.path)}
                      >
                        <Text size="sm">{sub.label}</Text>
                      </Button>
                    ))}
                </List>
              </Collapse>
            </div>
          </div>
        ) : (
          <ListItem disablePadding key={item.label}>
            <Button
              customVariant={activePage === item.label ? "primary" : "muted"}
              size="full"
              onClick={() => handleClick(item.path)}
            >
              <Text>{item.label}</Text>
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
}

export default NavbarList;
